<div
  class="root"
  [rkDndDropzone]="['track', 'chronic', 'tag', 'playlist_auto', 'playlist_manual']"
  (dndDrop)="dropped($event)"
  [dndDisableIf]="playlist.type !== 'manual'"
>
  <div class="head">
    <a class="link" routerLink="/radio/{{ radioId }}/media/playlist/{{ playlist.id }}">
      <div class="bac-icon">
        <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
      </div>
      <span data-cy="playlist-list-name">{{ playlist.name }}</span>
    </a>
    <div class="toggle-left">
      <span
        *ngIf="!updating && !(processing$ | async); else updatingtpl"
        class="count"
        data-cy="playlist-list-count"
        >{{ playlist.nbTracks }}</span
      >
    </div>
  </div>
</div>
<ng-template #updatingtpl>
  <rk-loader [size]="20" [isLoading]="true"></rk-loader>
</ng-template>
